import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["label", "error", "components"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { multiRef } from '@isyc-react/core/utils/reference';
import { BottomInputComponent } from "../../bottom";
import React from 'react';
import { defaultDateFormat, InputDateCalendarIcon, InputDateOverlay, InputDateSingle } from "../base";
import { InputDate } from "../normal/input-date.component";
import { nanoid } from 'nanoid';
export const InputDateBottom = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _rest$dateFormat, _rest$dateFormat2;
  const {
      label,
      error,
      components
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const inputRef = React.useRef(null);
  const onClick = e => {
    const target = e.target;
    const calendarYearMonthValueClick = target.closest('.flatpickr-current-month');
    if (inputRef.current && inputRef.current.input && !calendarYearMonthValueClick) {
      inputRef.current.input.focus();
    }
  };
  return /*#__PURE__*/React.createElement(BottomInputComponent, {
    label: label,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(InputDate, _extends({
    className: 'form-control-bottom',
    ref: multiRef(ref, inputRef),
    error: error,
    components: _objectSpread({
      IconList: [/*#__PURE__*/React.createElement(InputDateOverlay, {
        key: nanoid(4).toString(),
        OverlayTrigger: InputDateCalendarIcon,
        dateFormat: (_rest$dateFormat = rest.dateFormat) !== null && _rest$dateFormat !== void 0 ? _rest$dateFormat : defaultDateFormat,
        readOnly: rest.readOnly,
        disabled: rest.disabled,
        error: error
      }, /*#__PURE__*/React.createElement(InputDateSingle, _extends({
        dateFormat: (_rest$dateFormat2 = rest.dateFormat) !== null && _rest$dateFormat2 !== void 0 ? _rest$dateFormat2 : defaultDateFormat,
        value: rest.value,
        onChange: rest.onChange,
        readOnly: rest.readOnly,
        disabled: rest.disabled
      }, rest)))]
    }, components)
  }, rest)));
});